import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Environment, Feature } from '@enums';

/**
 * Features service.
 *
 * @author Mikhail Siutsou
 * @class FeaturesServiceClass
 * @category Services
 */
var FeaturesServiceClass = /*#__PURE__*/function () {
  function FeaturesServiceClass() {
    var _Feature$ServiceWorke, _Feature$MockAPI, _Feature$Encryption, _defineProperty2;

    _classCallCheck(this, FeaturesServiceClass);

    _defineProperty(this, "configs", (_defineProperty2 = {}, _defineProperty(_defineProperty2, Feature.ServiceWorker, (_Feature$ServiceWorke = {}, _defineProperty(_Feature$ServiceWorke, Environment.Dev, true), _defineProperty(_Feature$ServiceWorke, Environment.Test, true), _defineProperty(_Feature$ServiceWorke, Environment.Preprod, true), _defineProperty(_Feature$ServiceWorke, Environment.Prod, true), _Feature$ServiceWorke)), _defineProperty(_defineProperty2, Feature.MockAPI, (_Feature$MockAPI = {}, _defineProperty(_Feature$MockAPI, Environment.Dev, true), _defineProperty(_Feature$MockAPI, Environment.Test, true), _defineProperty(_Feature$MockAPI, Environment.Preprod, true), _defineProperty(_Feature$MockAPI, Environment.Prod, true), _Feature$MockAPI)), _defineProperty(_defineProperty2, Feature.Encryption, (_Feature$Encryption = {}, _defineProperty(_Feature$Encryption, Environment.Dev, true), _defineProperty(_Feature$Encryption, Environment.Test, false), _defineProperty(_Feature$Encryption, Environment.Preprod, true), _defineProperty(_Feature$Encryption, Environment.Prod, true), _Feature$Encryption)), _defineProperty2));
  }

  _createClass(FeaturesServiceClass, [{
    key: "available",
    value:
    /**
     * Is feature available.
     *
     * @author Mikhail Siutsou
     * @private
     * @param {Feature} featureName feature name.
     * @return {boolean} available.
     */
    function available(featureName) {
      return FeaturesServiceClass.isFeatureAvailable(this.configs[featureName]);
    }
  }], [{
    key: "isFeatureAvailable",
    value:
    /**
     * Is feature available by config.
     *
     * @author Mikhail Siutsou
     * @private
     * @param {FeatureAvailableConfig} config feature config.
     * @return {boolean} available.
     */
    function isFeatureAvailable(config) {
      switch (process.env.server) {
        case 'dev':
          {
            return config.dev;
          }

        case 'test':
          {
            return config.test;
          }

        case 'preprod':
          {
            return config.preprod;
          }

        case 'prod':
          {
            return config.prod;
          }

        default:
          {
            return false;
          }
      }
    }
  }]);

  return FeaturesServiceClass;
}();

var FeaturesService = new FeaturesServiceClass();
export { FeaturesService };